/* Tatemada Walmart store locator — Leaflet + OpenStreetMap tiles, ZIP search via Nominatim, geolocation, haversine sort.
   Expects window.TATEMADA_STORES (array of {n,a,c,s,z,lat,lng,num}) to already be loaded. No online-buy
   button here by design. "num" (Walmart store number) is optional — stores without it just send an empty
   store_number in directions_click until the real numbers are merged into walmart-stores-data.js. */
(function () {
  function init() {
    var listEl = document.getElementById('wmtStoreList'), msgEl = document.getElementById('wmtLocMsg');
    var input = document.getElementById('wmtZip');
    if (!listEl || !window.L || !window.TATEMADA_STORES) return;
    var map, meMarker, markers = [], origin = null;
    var LIMIT = 6;

    function say(t) { msgEl.textContent = t; msgEl.style.display = t ? 'block' : 'none'; }
    function miles(a, b, c, d) {
      var R = 3958.8, p = Math.PI / 180, x = (c - a) * p, y = (d - b) * p;
      var h = Math.sin(x / 2) * Math.sin(x / 2) + Math.cos(a * p) * Math.cos(c * p) * Math.sin(y / 2) * Math.sin(y / 2);
      return R * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
    }
    function dirUrl(s) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(s.a + ', ' + s.c + ', ' + s.s + ' ' + s.z);
    }
    // Before any search: show the priority chains (section setting "priority chains") alternating.
    // With an initial map center set, picks the stores closest to it (one per city) so the first pins
    // sit inside the starting view; otherwise one store per state. Falls back to the file order.
    function startView() {
      var sec = document.getElementById('locator');
      var c = ((sec && sec.getAttribute('data-center')) || '').split(',').map(parseFloat);
      var z = parseInt(sec && sec.getAttribute('data-zoom'), 10);
      return (c.length === 2 && !isNaN(c[0]) && !isNaN(c[1])) ? { c: c, z: isNaN(z) ? 6 : z } : null;
    }
    function featured(all) {
      var sec = document.getElementById('locator'), sv = startView();
      var names = ((sec && sec.getAttribute('data-priority')) || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
      if (!names.length) return all.slice(0, LIMIT);
      var lists = names.map(function (nm) {
        var seen = {}, byState = {}, out = [];
        var of = all.filter(function (st) { return st.n.split(' \u00b7 ')[0].toLowerCase() === nm && !st.approx; });
        if (sv) {
          of.sort(function (a, b) { return miles(sv.c[0], sv.c[1], a.lat, a.lng) - miles(sv.c[0], sv.c[1], b.lat, b.lng); });
          of.forEach(function (st) { var k = st.c + st.s; if (!seen[k]) { seen[k] = 1; out.push(st); } });
        } else {
          of.forEach(function (st) { byState[st.s] = (byState[st.s] || 0) + 1; });
          of.forEach(function (st) { if (!seen[st.s]) { seen[st.s] = 1; out.push(st); } });
          out.sort(function (a, b) { return byState[b.s] - byState[a.s]; });
        }
        return out;
      }).filter(function (x) { return x.length; });
      var res = [], i = 0;
      while (res.length < LIMIT && lists.some(function (x) { return x.length > i; })) {
        lists.forEach(function (x) { if (x[i] && res.length < LIMIT) res.push(x[i]); });
        i++;
      }
      return res.length ? res : all.slice(0, LIMIT);
    }
    function nearest() {
      var l = window.TATEMADA_STORES.map(function (s) {
        return Object.assign({}, s, { d: origin ? miles(origin.lat, origin.lng, s.lat, s.lng) : null });
      });
      if (origin) { l.sort(function (a, b) { return a.d - b.d; }); return l.slice(0, LIMIT); }
      return featured(l);
    }
    function render() {
      var l = nearest();
      if (!l.length) { listEl.innerHTML = '<div class="tm-wmt-store-empty">No stores found nearby yet.</div>'; return; }
      listEl.innerHTML = l.map(function (s, i) {
        return '<div class="tm-wmt-store" data-i="' + i + '">' +
          '<div class="tm-wmt-n">' + (i + 1) + '</div>' +
          '<div style="flex:1"><div class="tm-wmt-name">' + s.n + '</div>' +
          '<div class="tm-wmt-addr">' + s.a + ', ' + s.c + ', ' + s.s + ' ' + s.z + '</div>' +
          '<div class="tm-wmt-acts"><a class="tm-wmt-a-dir" data-store-num="' + (s.num || '') + '" data-city="' + s.c + '" data-state="' + s.s + '" href="' + dirUrl(s) + '" target="_blank" rel="noopener">Get directions</a></div></div>' +
          (s.d != null ? '<div class="tm-wmt-dist">' + s.d.toFixed(1) + ' mi</div>' : '') +
          '</div>';
      }).join('');
      drawPins(l);
      [].slice.call(listEl.querySelectorAll('.tm-wmt-store')).forEach(function (row) {
        row.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;
          var s = l[+row.dataset.i];
          [].slice.call(listEl.children).forEach(function (r) { r.classList.remove('on'); });
          row.classList.add('on');
          map.setView([s.lat, s.lng], 13);
          markers[+row.dataset.i].openPopup();
        });
      });
    }
    function drawPins(l) {
      markers.forEach(function (m) { map.removeLayer(m); }); markers = [];
      l.forEach(function (s, i) {
        var m = L.marker([s.lat, s.lng], {
          icon: L.divIcon({ className: '', iconSize: [28, 28], iconAnchor: [14, 28], html: '<div class="tm-wmt-pin-i"><span>' + (i + 1) + '</span></div>' })
        }).addTo(map);
        m.bindPopup('<b>' + s.n + '</b><br>' + s.a + '<br><a class="tm-wmt-a-dir" data-store-num="' + (s.num || '') + '" data-city="' + s.c + '" data-state="' + s.s + '" href="' + dirUrl(s) + '" target="_blank" rel="noopener">Get directions</a>');
        markers.push(m);
      });
      var pts = l.map(function (s) { return [s.lat, s.lng]; });
      if (origin) pts.push([origin.lat, origin.lng]);
      var sv = startView();
      if (!origin && sv) map.setView(sv.c, sv.z);
      else if (pts.length) map.fitBounds(L.latLngBounds(pts).pad(0.25), { maxZoom: 12 });
    }
    function setOrigin(lat, lng, method) {
      origin = { lat: lat, lng: lng };
      if (meMarker) map.removeLayer(meMarker);
      meMarker = L.marker([lat, lng], { icon: L.divIcon({ className: '', iconSize: [18, 18], iconAnchor: [9, 9], html: '<div class="tm-wmt-pin-me"></div>' }) }).addTo(map);
      meMarker.bindPopup('You are here');
      render();
      if (method && window.tmPushFindInStore) window.tmPushFindInStore(method);
    }
    function byZip(z) {
      z = (z || '').trim();
      if (!/^\d{5}$/.test(z)) { say('Enter a valid 5-digit ZIP code.'); return; }
      say('Searching…');
      fetch('https://nominatim.openstreetmap.org/search?format=json&countrycodes=us&limit=1&postalcode=' + z)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d.length) { say('We could not find that ZIP. Try another.'); return; }
          say(''); setOrigin(parseFloat(d[0].lat), parseFloat(d[0].lon), 'zip');
        })
        .catch(function () { say('Search is unavailable right now. Try "Use my location".'); });
    }

    map = L.map('wmtMap', { scrollWheelZoom: false }).setView([32.95, -96.75], 9);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OpenStreetMap contributors', maxZoom: 19 }).addTo(map);
    render();

    document.addEventListener('click', function (e) {
      var dir = e.target.closest('.tm-wmt-a-dir');
      if (!dir || !window.tmPublish) return;
      window.tmPublish('directions_click', {
        store_number: dir.getAttribute('data-store-num') || '',
        city: dir.getAttribute('data-city') || '',
        state: dir.getAttribute('data-state') || ''
      });
    });

    document.getElementById('wmtZipGo').addEventListener('click', function () { byZip(input.value); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); byZip(input.value); } });
    document.getElementById('wmtGeoBtn').addEventListener('click', function (e) {
      e.preventDefault();
      if (!navigator.geolocation) { say('Your browser does not support location sharing.'); return; }
      say('Locating…');
      navigator.geolocation.getCurrentPosition(
        function (p) { say(''); input.value = ''; setOrigin(p.coords.latitude, p.coords.longitude, 'geolocation'); },
        function () { say('We could not get your location. Enter your ZIP instead.'); }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
